module.exports = __webpack_public_path__ + "static/media/Lato-Light.f014a7e8.eot";